<template>
  <div id="product">
    <div class="header">
      <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>展品类别</el-breadcrumb-item>
      </el-breadcrumb> -->
      <div  style="padding-bottom:10px;color:red;font-size:16px;">特别提示：本届展会将不再印刷纸质会刊，请您填写、修改后点击下方按钮保存并提交，产品内容将会收录在电子会刊中！</div>
    </div>
    <div class="paragraph">
      <div class="tltie">主要产品：请输入产品关键字检索您的产品（最多20个） <span style="background:#ddd;padding:4px;border-radius:4px">已选中<span style="color:red;padding:0 4px">{{chEcho.length}}</span>个</span><span style="color:red;padding-left:8px">请逐个产品进行检索</span></div>
      <div class="showLabel">
        <el-tag
          v-for="(tag,ind) in chEcho"
          :key="tag.typID"
          @close="labelClose(tag.typID,'ch',ind)"
          closable>
          {{tag.typName}}
        </el-tag>
      </div>
      <div class="elTabel">
        <!-- <el-tabs v-model="chHeaderTab" @tab-click="handleClick('ch')">
          <el-tab-pane :label="item.typName" :name="ind+'_c'" v-for="(item,ind) in chLabelList" :key="ind"></el-tab-pane>
        </el-tabs> -->
        <div class='searchBox'>
          <el-input v-model.trim="chHeaderTab" placeholder="请输入产品关键字查询"  @input='chSearch("ch")' clearable ><i slot="suffix" class="el-input__icon el-icon-search"></i></el-input>
        </div>
        <div class="checkWarp">
          <el-checkbox-group v-model="chCheckList" @change="labelChange($event,'ch')">
            <el-checkbox :label='item.typID' v-for="(item) in chlabelData" :key="item.typID" :disabled='setDisable(item.typID,"ch")'>{{item.typName}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <div class="paragraph">
      <div class="tltie">Main Products: Please enter product keywords to query your products(Max 20) <span style="background:#ddd;padding:4px;border-radius:4px">Selected <span style="color:red;padding:0 4px">{{enEcho.length}}</span>个</span><span style="color:red;padding-left:8px">Search each product individually. </span></div>
      <div class="showLabel">
        <el-tag
          v-for="(tag,ind) in enEcho"
          :key="tag.typID"
          @close="labelClose(tag.typID,'en',ind)"
          closable>
          {{tag.typEName}}
        </el-tag>
      </div>
      <div class="elTabel">
        <!-- <el-tabs v-model="enHeaderTab" @tab-click="handleClick('en')">
          <el-tab-pane :label="item.typEName" :name="ind+'_e'" v-for="(item,ind) in enLabelList" :key="ind"></el-tab-pane>
        </el-tabs> -->
        <div class='searchBox'>
          <el-input v-model.trim="enHeaderTab" placeholder="Please enter product keywords to query"  @input='chSearch("en")' clearable ><i slot="suffix" class="el-input__icon el-icon-search"></i></el-input>
        </div>
        <div class="checkWarp">
          <el-checkbox-group v-model="enCheckList"  @change="labelChange($event,'en')">
            <el-checkbox :label='item.typID' v-for="(item) in enlabelData" :key="item.typID" :disabled='setDisable(item.typID,"en")'>{{item.typEName}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <div class="paragraph">
      <div class="tltie">自定义产品：如果展出产品在“主要产品”库中无法被检索到，可在此自定义填写，可填写20个产品，单个产品字符数不超过200个</div>
      <div class="showLabel">
        <el-tag
          v-for="(tag,ind) in zdyCn"
          :key="ind"
          @close="handleClose(tag)"
          closable>
          {{tag}}
        </el-tag>
        <div class="zjInput"  v-if="chInputShow" >
          <!-- <el-autocomplete
            ref="cnZdyInputFocus"
            class="inline-input"
            v-model.trim="cnZdyInput"
            :fetch-suggestions="chQuerySearch"
            value-key='typName'
            placeholder="请输入内容"
            @keyup.enter.native="chInputBlur"
            @select="chSelect"
            size='small'
            :maxlength="maxlength" show-word-limit
          >  <el-button slot="append" size='small' @click="chInputBlur">确认</el-button></el-autocomplete> -->
          <el-input v-model.trim="cnZdyInput" placeholder="" v-if="chInputShow"  @keyup.enter.native="chInputBlur" @input="textChange()"  maxlength="200" show-word-limit ref="cnZdyInputFocus" size='small' >
            <el-button slot="append" size='small' @click="chInputBlur">确认</el-button>
          </el-input>
        </div>
        <el-button  icon="el-icon-plus" @click="addZdyCn" v-if="!chInputShow && zdyCn.length<20" size='small'></el-button>
      </div>
    </div>
    <div class="paragraph"> 
      <div class="tltie">Self-define Products: If exhibit products are not in 'Main Products' database, manually enter up to 20 here(Max 200 chars for each product)</div>
      <div class="showLabel">
        <el-tag
          v-for="(tag,ind) in zdyEn"
          :key="ind"
          @close="enLabelClose(tag)"
          closable>
          {{tag}}
        </el-tag>
        <div class="zjInput" v-if="ehInputShow">
         
          <!-- <el-autocomplete
            ref="enZdyInputFocus"
            class="inline-input"
            v-model.trim="enZdyInput"
            :fetch-suggestions="enQuerySearch"
            value-key='typEName'
            placeholder=""
            @keyup.enter.native="ehInputBlur"
            @select="enSelect"
            size='small'
            :maxlength="maxlength" show-word-limit
          >  <el-button slot="append" size='small' @click="ehInputBlur">确认</el-button></el-autocomplete>
 -->
          <el-input v-model="enZdyInput" placeholder="" v-if="ehInputShow"  @keyup.enter.native="ehInputBlur"   maxlength="200" show-word-limi  ref="enZdyInputFocus" size='small'  @blur="enZdyInput=$event.target.value.trim()">  <el-button slot="append" size='small' @click="ehInputBlur">OK</el-button></el-input>        
        </div>
        <el-button  icon="el-icon-plus" @click="addZdyEn" v-if="!ehInputShow  && zdyEn.length<20" size='small'></el-button>
      </div>
    </div>
    <div style="padding-bottom:40px">
      <el-button type="primary" :style="buttonStyle" @click="onSubmit('1')" :disabled="Dsave">暂存</el-button>
      <el-button type="primary" :style="buttonStyle" @click="onSubmit('')" :disabled="saveBtnStatue">提交</el-button>
    </div>   
  </div>
</template>
<script>
import api from '@/api'
import tools from '../../utils/tools.js';
export default {
  name: 'Product',
  data() {
    return {
      productList:[],
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {},
      catalogdetail:'',

      originData:[],   // 产品类别原始平铺记录 用于回显查询
      chHeaderTab:'',
      chCheckList:[],  //中文选中的值 

      enHeaderTab:'',
      enCheckList:[],  //英文选中的值 

      chlabelData:[],  //中文下面的选择标签
      enlabelData:[],  //英文下面的选择标签

      chLabelList:[],  //中文产品集合
      enLabelList:[],  //英文产品集合

      chEcho:[],   //中文回显集合
      enEcho:[],   ///英文回显集合

      zdyCn:[],  //中文字自定义Input值例表
      cnZdyInput:'', //中文字自定义Input值
      chInputShow:false,//中文字自定义Input显示隐藏


      zdyEn:[],  //英文字自定义Input值例表
      enZdyInput:'',  //英文字自定义Input值
      ehInputShow:false, //英文字自定义Input显示隐藏

      maxlength:35,
      Dsave: true,
      saveBtnStatue: true
    }
  },
  mounted() {
    this.isPC = tools.isPC()
    this.getProductType()
  },
  methods: {
    textChange(){
      for(var i = 0;i<keyText.length;i++){
        this.cnZdyInput = this.cnZdyInput.replace(new RegExp(keyText[i],'g'),'')
      }
    },
    chSearch(str){
      var _key = str == 'ch' ? 'typName' : 'typEName'
      var _temp = []
      if(this[str+'HeaderTab'] != ''){
        // console.log(this[str+'HeaderTab'])
        _temp = this.originData.filter(item => {
          if(item[_key] && item[_key].toLowerCase().indexOf(this[str+'HeaderTab'].toLowerCase())>-1 && item.typParentID !=''){
            return true
          }else{
            return false
          }
        })
      }
      this[str+'labelData'] = _temp
      // console.log(_temp)
    },
    //获取展品分类
    getProductType(){
      api.searchproducttype().then((res)=>{
        if(res.data.code =='200'){
          var _data = res.data.data
          this.originData = _data
          // console.log(this.originData)
          // for(var i=0;i<this.originData.length;i++){
          //   console.log(this.originData[i].typEName)
          //   console.log(this.originData[i].typName)
          // }
          // var _originData = this.handleTree(_data,'typID','typParentID')
          this.getData()
        }
      })
    },
    // 中文自定义增加
    addZdyCn(){
      this.chInputShow = true
      this.$nextTick(function () {
        this.$refs['cnZdyInputFocus'].$refs.input.focus();
      })
    },
    // 中文Input失去Input
    chInputBlur(){
      if(this.cnZdyInput !=''){
        var tempList = this.repelKey('ch', this.cnZdyInput,this.originData)
        if(tempList.length>0){
          var isAdd = this.repelKey('ch', this.cnZdyInput,this.chEcho)
          if(isAdd.length>0){
            this.$message({
              customClass:'errorType',
              message: '该产品在主要产品中已存在，请输入下一个自定义产品',
              showClose:true,
              type: 'error',
            });
          }else{
            this.chEcho.push(tempList[0])
            this.chCheckList.push(tempList[0].typID)
            this.chInputShow = false
            this.cnZdyInput = ''
          }
        }else{
          this.chInputShow = false
          this.zdyCn.push(this.cnZdyInput)
          this.cnZdyInput = ''
        }
      }else{
        this.chInputShow = false
        this.cnZdyInput = ''
      }
    },
    chSelect(item){
      this.chInputShow = false
      this.zdyCn.push(item.typName)
      this.cnZdyInput = ''
    },
    chQuerySearch(queryString, cb){
      this.zdySearchCommon(queryString, cb,'ch')
    },
    enQuerySearch(queryString, cb){
      this.zdySearchCommon(queryString, cb,'en')
    },
    zdySearchCommon(queryString, cb,str){
      if (queryString !== '') {
        var _key = str == 'ch' ? 'typName' : 'typEName'
        var resultes = this.originData.filter(item => {
          if(item[_key].indexOf(queryString)>-1){
            return true
          }else{
            return false
          }
        })
        cb(resultes);
      } else {
        cb([]);
      }
    },
    //中文关闭标签
    handleClose(tag) {
      this.zdyCn.splice(this.zdyCn.indexOf(tag), 1);
    },
    // 英文自定义下拉选择
    enSelect(item){
      this.ehInputShow = false
      this.zdyEn.push(item.typEName)
      this.enZdyInput = ''
    },
    // 英文自定义增加
    addZdyEn(){
      this.ehInputShow = true
      this.$nextTick(function () {
        this.$refs['enZdyInputFocus'].$refs.input.focus();
      })
    },
    // 英文Input失去Input
    ehInputBlur(){
      if(this.enZdyInput !=''){
        var tempList = this.repelKey('en', this.enZdyInput,this.originData)
        if(tempList.length>0){
          var isAdd = this.repelKey('en', this.enZdyInput,this.enEcho)
          if(isAdd.length>0){
            this.$message({
              message: '该产品在主要产品中已存在，请输入下一个自定义产品',
              showClose:true,
              customClass:'errorType',
              type: 'error',
            });
          }else{
            this.enEcho.push(tempList[0])
            this.enCheckList.push(tempList[0].typID)
            this.ehInputShow = false
            this.enZdyInput = ''
          }
        }else{
          this.ehInputShow = false
          this.zdyEn.push(this.enZdyInput)
          this.enZdyInput = ''
        }
      }else{
        this.ehInputShow = false
        this.enZdyInput = ''
      }
    },
    //英文关闭标签
    enLabelClose(tag) {
      this.zdyEn.splice(this.zdyEn.indexOf(tag), 1);
    },
    // 自定义标签输入 排斥 库里面没有的
    repelKey(str,val,originArr){
      var _key = str == 'ch' ? 'typName' : 'typEName'
      var resultes = originArr.filter(item => {
        if(item[_key] && item[_key].toLowerCase() == val.toLowerCase() && item.typParentID !=''){
          return true
        }else{
          return false
        }
      })
      return resultes
    },
    setDisable(id,str){
      this[str+'CheckList']
      if(this[str+'CheckList'].indexOf(id)>-1){
        return false
      }else{
        if(this[str+'CheckList'].length>=20){
          return true
        }else{
          return false
        }
      }
    },
    //产品标签删除 关联checkBox选择
    labelClose(tag,str,ind){
      this[str+'CheckList'].splice(this[str+'CheckList'].indexOf(tag), 1);
      this[str+'Echo'].splice(ind, 1);
    },
    // checkboxa切换 用于  收集回显
    labelChange(event,str){
      var _currentSelect = this[str+'CheckList']
      this[str+'Echo'] = []
      for(var j=0;j<_currentSelect.length;j++){
        for(var i=0;i<this.originData.length;i++){
          if(this.originData[i].typID == _currentSelect[j]){
            this[str+'Echo'].push(this.originData[i])
          }
        }
      }
    },
    // 头部切换
    handleClick(str) {
      this.changeLabel(str)
    },
    // 头部切换获取对应的下面选项
    changeLabel(str){
      var _ind = this[str+'HeaderTab'].split('_')[0]
      this[str+'labelData'] = this[str+'LabelList'][_ind].children
    },
    //获取
    getData(){
      api.getProductTypeDetail().then((res)=>{
        if(res.data.code =='200' && res.data.data){
          var _tempData =  res.data.data
          this.chCheckList = _tempData.pdtField1!='' ? _tempData.pdtField1.split("||") : []
          this.enCheckList = _tempData.pdtField2!='' ? _tempData.pdtField2.split("||"): []
          this.zdyCn = _tempData.pdtField3!='' ? _tempData.pdtField3.split("||"): []
          this.zdyEn = _tempData.pdtField4!='' ? _tempData.pdtField4.split("||"): []
          if (_tempData.pdtSysState === '正常') {
            this.Dsave = true
          } else {
            this.Dsave = false
          }
          this.saveBtnStatue = false
        // console.log(this.chCheckList)
        // console.log(this.enCheckList,'英文选 择')
        // console.log(this.zdyCn)
        // console.log(this.zdyEn)
        } else {
          this.saveBtnStatue = false
          this.Dsave = false
        }
        // var _originData = this.handleTree(this.originData,'typID','typParentID')
        //   this.chLabelList = JSON.parse(JSON.stringify(_originData)) 
        //   this.enLabelList = JSON.parse(JSON.stringify(_originData)) 
          // this.changeLabel('ch')
          // this.changeLabel('en')
        this.labelChange('','ch')
        this.labelChange('','en')
      })
    },
    onSubmit(IsCache){
      this.saveBtnStatue = true
      // console.log(this.chCheckList)
      // console.log(this.enCheckList,'英文选择')
      // console.log(this.zdyCn)
      // console.log(this.zdyEn)
      // console.log(this.chInputShow)
      if(this.cnZdyInput == ''){
        this.chInputShow = false
        this.cnZdyInput = ''
      }
      if(this.enZdyInput == ''){
        this.ehInputShow = false
        this.enZdyInput = ''
      }
      if( this.chInputShow || this.ehInputShow ){
        this.$alert('请先点击确认或OK按钮，再点击保存', '自定义产品', {
          confirmButtonText: '确定',
          callback: action => {
            // console.log('asdfasdf')
          }
        });
        this.saveBtnStatue = false
        return false
      }
      var tempData = {
        pdtField1:this.chCheckList.join("||"),   // 中文产品
        pdtField2:this.enCheckList.join("||"),  //英文产品
        pdtField3:this.zdyCn.join("||"),  // 自定义中文
        pdtField4:this.zdyEn.join("||")  // 自定义英文
      }
      tempData.IsCache = IsCache
      api.saveProductType(tempData).then((res) => {
        if (res.data.code === 200) {
          if (IsCache === ''){
            this.$confirm('<span style="font-size:18px">请继续产品图片上传</span>', '提示', {
              confirmButtonText: '确定',
              type: 'none',
              showCancelButton:false,
              closeOnClickModal:false,
              closeOnPressEscape:false,
              dangerouslyUseHTMLString:true,
              showClose:false,
              center: true
            }).then(() => {
              this.$router.push(`/addProduct`)
            })
          }
          this.$notify({
            title: '保存成功',
            type: 'success',
            duration: 2000
          })
        } else {
          this.saveBtnStatue = false
        }
      })
    },
    /**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
    handleTree(data, id, parentId, children) {
      let config = {
        id: id || 'id',
        parentId: parentId || 'parentId',
        childrenList: children || 'children'
      };
      var childrenListMap = {};
      var nodeIds = {};
      var tree = [];
      for (let d of data) {
        let parentId = d[config.parentId];
        if (childrenListMap[parentId] == null) {
          childrenListMap[parentId] = [];
        }
        nodeIds[d[config.id]] = d;
        childrenListMap[parentId].push(d);
      }
      for (let d of data) {
        let parentId = d[config.parentId];
        if (nodeIds[parentId] == null) {
          tree.push(d);
        }
      }
      for (let t of tree) {
        adaptToChildrenList(t);
      }
      function adaptToChildrenList(o) {
        if (childrenListMap[o[config.id]] !== null) {
          o[config.childrenList] = childrenListMap[o[config.id]];
        }
        if (o[config.childrenList]) {
          for (let c of o[config.childrenList]) {
            adaptToChildrenList(c);
          }
        }
      }
      return tree;
    }
  }
}
</script>
<style lang="less" scoped>
.noData{
  text-align: center;
  width: 100%;
  font-size: 16px;
  color:#999
}

#product{
  padding-top:30px !important;

  .paragraph{
    padding:0px 0 40px
  }
  .searchBox{
    width:40%;
    padding-bottom: 20px;
  }
  .elTabel{
    padding-top:10px
  }

  .tltie{
    font-weight: bold;
    padding:4px 0;
    font-size: 16px;
  }
  .showLabel{
    padding:10px 0;
    display: flex;
    align-items:center;
    flex-wrap:wrap
  }
  .el-tag {
    margin:2px 2px
  }
  .el-checkbox{
    padding-bottom: 6px;
  }
  .zjInput{
    margin:0 2px
  }
  .checkWarp{
    min-height: 30px;
  }

  @media screen and (max-width:540px){


  }
}
</style>
